import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function InvoicelinedetailReducer(state = initialState.invoicelinedetail, action: any) {
  switch (action.type) {
    case types.SAVE_INVOICELINEDETAIL_SUCCESS:
      return action.invoicelinedetail;
    default:
      return state;
  }
}
